// extracted by mini-css-extract-plugin
module.exports = {"ImageDescription":"ImageDescription_ImageDescription__I0Ga_","ImageDescription__Title":"ImageDescription_ImageDescription__Title__e7LIi"};